<div *ngIf="(control?.touched ) && control?.errors" class="invalid-fields">
  <div *ngFor="let error of control?.errors  | keyvalue ">
    {{'validationMessage.errors.'+error.key.toString()| translate: translationParams(error.key) }}
  </div>
</div>